module.exports = __webpack_public_path__ + "img/face59.9b0a1921.gif";